import { render, staticRenderFns } from "./RxDocumentos.vue?vue&type=template&id=49ecd6aa&scoped=true&"
import script from "./RxDocumentos.vue?vue&type=script&lang=ts&"
export * from "./RxDocumentos.vue?vue&type=script&lang=ts&"
import style0 from "./RxDocumentos.vue?vue&type=style&index=0&id=49ecd6aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ecd6aa",
  null
  
)

export default component.exports